export default "__VITE_ASSET__BOlzE2QT__"